module.exports = __webpack_public_path__ + "img/bay-room-3.0ba54b94.jpg";